module.exports = __webpack_public_path__ + "img/d4892b6.jpg";